import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Cascader,
  Checkbox,
  Form,
  Input,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Select,
  Space,
} from "antd";
import { QuestionCircleTwoTone, SearchOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { getAddItemPageAsync } from "./addItemSlice";
import { submitMemberInterestBatchAsync, submitMemberInterestExceptionAsync } from "../memberBenefitsSlice";
import { EditableList } from "../../../compnents/list/EditableList";
import { RootDispatch } from '../../../app/store'
import styles from '../MembersManagementPage.module.css'
import {
  InvoiceBillingCategories,
  BillingCategoryName,
} from "../../../models/billingCategory";
import { useCascaderDropdownRender } from "../../storesearch/query";
import { getMaterialsName, Materiales } from "../../../models/commodity";
import { getCommonCodeCompletionsAsync } from "../../completion/completionSlice";
import { CommonCodeCategory } from "../../../models/commoncode";
import { selectSettings } from "../../../features/user/setting/settingSlice";
import { Checks } from "../../../models/setting";

const normalizeMaterialsCategory = (value: any) => {
  if (!value) return [];
  if (Array.isArray(value) && value.length === 0) return [];
  if (Array.isArray(value) && Array.isArray(value[0])) return value;
  if (Array.isArray(value)) return [value];
  return [];
};

const getMaterialsCategoryInfo = (materialsCategoryList: any) => {
  const materialsCategory = materialsCategoryList?.filter(
    (v: any) => v?.length == 1,
  );
  const category = materialsCategoryList
    ?.filter((v: any) => v?.length != 1)
    .map((item: any) => item?.[1]);
  return {
    materialsCategory: materialsCategory?.length
      ? materialsCategory?.join(",")
      : "",
    category: category?.length ? category?.join(",") : "",
    materialsCategoryList: materialsCategoryList,
  };
};

const getProcuctInfo = (item: any, settings: any) => {
  const materialsCategory = item.materialsCategory;
  const packSpec = item.packSpec ? item.packSpec : "-";
  const doseCategory = item.doseCategory ? item.doseCategory : "-";
  const tenantSupplierName = item.tenantSupplierName
    ? item.tenantSupplierName
    : "-";
  const spec = item.spec ? item.spec : "-";
  const model = item.model ? item.model + "/" : "";
  if (settings?.[Checks.MLKG] == 1) {
    if (materialsCategory == "0") {
      return packSpec + "/" + doseCategory + "/" + tenantSupplierName;
    } else if (materialsCategory == "1" || materialsCategory == "2") {
      return packSpec + "/" + model + tenantSupplierName;
    } else {
      return packSpec + "/" + tenantSupplierName;
    }
  } else {
    if (materialsCategory == "0") {
      return packSpec + "/" + doseCategory + "/" + tenantSupplierName;
    } else if (materialsCategory == "1" || materialsCategory == "2") {
      return spec + "/" + model + tenantSupplierName;
    } else {
      return spec + "/" + tenantSupplierName;
    }
  }
};

interface AddItemProps {
  visible: boolean;
  onCancel: () => void;
  onOk: (selectedRows: any[]) => void;
  title?: string;
  mode?: "full" | "exception";
  billingCategory?: string;
  defaultSelectedRowKeys?: React.Key[];
  defaultSelectedRows?: any[];
}

export const AddItem = ({
  visible,
  onCancel,
  onOk,
  title = "添加商品",
  mode = "full",
  billingCategory,
  defaultSelectedRowKeys,
  defaultSelectedRows,
}: AddItemProps) => {
  const dispatch = useDispatch<RootDispatch>();
  const settings = useSelector(selectSettings);
  const [form] = Form.useForm();

  const [data, setData] = useState<any[]>([]);
  const [total, setTotal] = useState(0);
  const [pageLoading, setPageLoading] = useState(false);

  const [queries, setQueries] = useState<any>({ size: 10, current: 1, state: 1 });
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [treeData, setTreeData] = useState<any>([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showSelectedOnly, setShowSelectedOnly] = useState(false);
  const dataRef = useRef(data)
  dataRef.current = data

  // 初始化默认选中项（编辑例外回显）
  useEffect(() => {
    if (visible && defaultSelectedRowKeys && defaultSelectedRows) {
      setSelectedRowKeys(defaultSelectedRowKeys);
      setSelectedRows(defaultSelectedRows);
    }
  }, [visible]);

  // 构建商品类别级联数据
  useEffect(() => {
    if (visible) {
      const data = Materiales.map((v) => ({
        id: v,
        value: v.toString(),
        label: getMaterialsName(v),
        children: [],
      }));

      dispatch(
        getCommonCodeCompletionsAsync({
          category: CommonCodeCategory.Durg,
          keyword: "",
        }),
      )
        .then(unwrapResult)
        .then((res) => {
          const tree = data.map((v) => {
            if (v.id == 0) {
              return {
                ...v,
                children: res.records.map((el: any) => ({
                  value: el.codeName,
                  label: el.codeName,
                })),
              };
            } else if (v.id == 1) {
              return {
                ...v,
                children: [
                  { value: "材料", label: "材料" },
                  { value: "器械", label: "器械" },
                  { value: "消耗品", label: "消耗品" },
                  { value: "其他", label: "其他" },
                ],
              };
            } else if (v.id == 2) {
              return {
                ...v,
                children: [
                  { value: "第一类医疗器械", label: "第一类医疗器械" },
                  { value: "第二类医疗器械", label: "第二类医疗器械" },
                  { value: "第三类医疗器械", label: "第三类医疗器械" },
                ],
              };
            } else if (v.id == 4) {
              return {
                ...v,
                children: [
                  { value: "食品", label: "食品" },
                  { value: "化妆品", label: "化妆品" },
                  { value: "保健品", label: "保健品" },
                  { value: "卫生消毒用品", label: "卫生消毒用品" },
                  { value: "初级农产品", label: "初级农产品" },
                  { value: "其他产品", label: "其他产品" },
                ],
              };
            } else {
              return v;
            }
          });
          setTreeData(tree);
        })
        .catch(() => {
          // ignore
        });
    }
  }, [visible]);

  const handleSearch = (): void => {
    const values = form.getFieldsValue();
    const materialsCategoryList = values?.materialsCategory;
    const categoryInfo = getMaterialsCategoryInfo(materialsCategoryList);
    const newQueries = {
      ...queries,
      ...values,
      ...categoryInfo,
      current: 1,
      filterFlag: mode !== 'exception' ? true : undefined,
    };
    // exception模式：使用当前编辑分类的开票项目过滤数据
    if (mode === 'exception' && billingCategory) {
      newQueries.billingCategory = billingCategory;
    }
    setQueries(newQueries);
  };

  // Cascader/Input/Select onChange 触发搜索
  const handleQuery = () => {
    handleSearch();
  };

  const dropdownRender = useCascaderDropdownRender(
    treeData,
    () => normalizeMaterialsCategory(form.getFieldValue("materialsCategory")),
    (v) => form.setFieldsValue({ materialsCategory: v }),
    handleQuery,
  );

  // 获取列表
  const getPage = () => {
    setPageLoading(true);
    dispatch(
      getAddItemPageAsync({
        ...queries,
        ...(mode !== 'exception' ? { filterFlag: true } : {}),
        materialsCategoryList: undefined,
        // exception模式：使用当前编辑分类的开票项目过滤数据
        ...(mode === 'exception' && billingCategory ? { billingCategory } : {}),
      }),
    )
      .then(unwrapResult)
      .then((res: any) => {
        const records: any[] = res?.records || []
        // 合并 defaultSelectedRows 中的 discountType/price
        if (defaultSelectedRows && defaultSelectedRows.length > 0) {
          const defaultMap = new Map<any, any>(defaultSelectedRows.map((r: any) => [r.id, r]))
          records.forEach((r: any) => {
            const def = defaultMap.get(r.id)
            if (def) {
              r.discountType = def.discountType ?? 0
              r.price = def.price ?? null
            }
          })
        }
        setData(records)
        setTotal(res?.total || 0)
      })
      .finally(() => {
        setPageLoading(false);
      });
  };

  // 弹框打开时重置到第一页
  useEffect(() => {
    if (visible) {
      setQueries({ size: 10, current: 1, state: 1 })
    }
  }, [visible])

  useEffect(() => {
    if (visible && !showSelectedOnly) {
      getPage();
    }
  }, [queries, visible, showSelectedOnly]);

  // “查看已选”：展示所有跨页已勾选的行，前端分页
  const allSelectedData = showSelectedOnly
    ? (() => {
        const dataMap = new Map(data.map((r: any) => [r.id, r]))
        return selectedRows.map((r: any) => {
          const current = dataMap.get(r.id)
          return current ? { ...r, ...current } : r
        })
      })()
    : data

  const currentPage = queries?.current || 1
  const pageSize = queries?.size || 10

  // 前端分页切片：普通模式直接用 data（后端已分页），查看已选模式手动切片
  const pagedData = showSelectedOnly
    ? allSelectedData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    : allSelectedData

  const displayTotal = showSelectedOnly ? allSelectedData.length : total

  const handleOk = () => {
    setSubmitLoading(true)
    setTimeout(() => {
      const currentData = dataRef.current
      // 将当前页data中的编辑数据合并到跨页累积的selectedRows中
      const dataMap = new Map<any, any>(currentData.map((r: any) => [r.id, r]))
      const mergedSelectedRows = selectedRows.filter(Boolean).map((r: any) => {
        const current = dataMap.get(r.id)
        return current ? { ...r, ...current } : r
      })

      if (mode === 'exception') {
        const params = {
          billingCategory,
          memberInterestExceptions: mergedSelectedRows.map((r: any) => ({
            tenantCatalogId: r.id,
            billingCategory,
          })),
        }
        dispatch(submitMemberInterestExceptionAsync(params))
          .then(unwrapResult)
          .then(() => {
            notification.success({ message: '编辑例外成功' })
            onOk([])
            handleCancel()
          })
          .finally(() => setSubmitLoading(false))
        return
      }

      if (mergedSelectedRows.length === 0) {
        notification.warning({ message: '请至少选择一项' })
        setSubmitLoading(false)
        return
      }

      const params = mergedSelectedRows.map((row: any) => ({
        name: row.name,
        catalogType: 0,
        tenantCatalogId: row.id,
        discountType: row.discountType ?? 0,
        price: (row.price == null || row.price === '')
          ? (row.discountType == 1 ? row.retailPrice : 100)
          : row.price,
      }))

      dispatch(submitMemberInterestBatchAsync(params))
        .then(unwrapResult)
        .then(() => {
          notification.success({ message: '添加成功' })
          handleCancel()
        })
        .finally(() => {
          setSubmitLoading(false)
        })
    }, 500)
  };

  const handleCancel = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setShowSelectedOnly(false);
    setQueries({ size: 10, current: 1, state: 1 });
    form.resetFields();
    onCancel();
  };

  const rowSelection = {
    preserveSelectedRowKeys: true,
    selectedRowKeys,
    onChange: (keys: React.Key[], rows: any[]) => {
      setSelectedRowKeys(keys)
      setSelectedRows((prev) => {
        const map = new Map(prev.filter(Boolean).map((r: any) => [r.id, r]))
        rows.filter(Boolean).forEach((r: any) => map.set(r.id, r))
        return Array.from(map.values()).filter((r: any) => r && keys.includes(r.id))
      })
    },
    onSelectAll: (selected: boolean, changeRows: any[]) => {
      const validRows = (changeRows || []).filter(Boolean)
      if (selected) {
        setSelectedRowKeys((prev) => Array.from(new Set([...prev, ...validRows.map((v: any) => v.id)])));
        setSelectedRows((prev) => {
          const map = new Map(prev.map((r: any) => [r.id, r]));
          validRows.forEach((r: any) => map.set(r.id, r));
          return Array.from(map.values());
        });
      } else {
        const changeIds = new Set(validRows.map((v: any) => v.id));
        setSelectedRowKeys((prev) => prev.filter((k) => !changeIds.has(k)));
        setSelectedRows((prev) => prev.filter((r: any) => !changeIds.has(r.id)));
      }
    },
  };

  const columns = [
    {
      title: "序号",
      key: "no",
      align: "center" as const,
      width: "3rem",
      render: (_1: any, _2: any, index: number) =>
        `${(queries.current - 1) * queries.size + index + 1}`,
    },
    {
      title: "商品信息",
      align: "left" as const,
      ellipsis: true,
      width: "300px",
      render: function Element(_: any, t: any) {
        const info = getProcuctInfo(t, settings)
        return (
          <Popover
            content={
              <div>
                <span
                  style={{
                    fontSize: "16px",
                    fontWeight: "bolder",
                    paddingRight: "15px",
                  }}
                >
                  {t.name}
                </span>
                <span style={{ color: "#999999", fontSize: "14px" }}>
                  {info}
                </span>
              </div>
            }
            placement="bottom"
          >
            <div
              style={{
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              <span
                style={{
                  fontSize: "16px",
                  fontWeight: "bolder",
                  paddingRight: "15px",
                }}
              >
                {t.name}
              </span>
              <span style={{ color: "#999999", fontSize: "14px" }}>{info}</span>
            </div>
          </Popover>
        );
      },
    },
    {
      title: "目录售价",
      dataIndex: "retailPrice",
      align: "center" as const,
      key: "retailPrice",
      width: "6rem",
      ellipsis: true,
      render: (_: any, r: any) =>
        r.retailPrice != null
          ? Number(r.retailPrice).toFixed(5)
          : '',
    },
    {
      title: "目录进价",
      dataIndex: "stockPrice",
      align: "center" as const,
      key: "stockPrice",
      width: "6rem",
      ellipsis: true,
      render: (_: any, r: any) =>
        r.stockPrice >= 0
          ? Number(r.stockPrice).toFixed(5)
          : "-",
    },
    {
      title: "可售库存",
      align: "center" as const,
      key: "count",
      width: "8rem",
      ellipsis: true,
      render: (_: any, r: any) => r.totalNumStr || '',
    },
    {
      title: (
        <Space size={4}>
          折扣类型
          <Popover
            content={
              <div style={{ width: "375px" }}>
                <p>
                  折扣价：根据开方时选择的商品的售价进行计算，如果是按照忽略库存或者合并批次开方则会员价=目录售价*折扣；如果是按照批次开方则会员价=该批次售价*折扣；
                </p>
                <p>特价：选择了特价后开方时固定取会员价格</p>
              </div>
            }
            placement="top"
            title="说明"
          >
            <QuestionCircleTwoTone />
          </Popover>
        </Space>
      ),
      dataIndex: "discountType",
      align: "center" as const,
      key: "discountType",
      width: "8rem",
      className: 'noRowSelect',
      render: function DiscountTypeCell(_: any, r: any) {
        return (
          <Radio.Group
            defaultValue={0}
            value={r.discountType || 0}
            onChange={(e) => {
              setData((prev) =>
                prev.map((item) =>
                  item.id === r.id
                    ? {
                        ...item,
                        discountType: e.target.value,
                        price: null,
                      }
                    : item,
                ),
              );
            }}
          >
            <Radio value={0}>折扣</Radio>
            <Radio value={1}>特价</Radio>
          </Radio.Group>
        );
      },
    },
    {
      title: "会员价",
      dataIndex: "price",
      align: "center" as const,
      key: "price",
      width: "5rem",
      colSpan: 2,
      className: "noRightBorder noRowSelect",
      editable: (r: any) => selectedRowKeys.includes(r.id),
      rules: (record: any) => [
        {
          required: true,
          message: "请输入会员价",
        },
        record.discountType == 1
          ? {
              pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,5})?$/),
              message: "请输入数字，支持小数点后五位",
            }
          : {
              pattern: new RegExp(/^(100|[1-9]?\d)$/),
              message: '折扣请输入0-100的整数',
            },
      ],
      onSave: (prev: any, next: any) => {
        const price = next.price;
        // 防重复保存：blur 回调时 form 已被重置为原始值，与 prev 一致则跳过
        const normalizedNew = price == null || price === '' ? null : price;
        const normalizedPrev = prev.price == null || prev.price === '' ? null : prev.price;
        if (normalizedPrev === normalizedNew) return;
        const val = Number(price);
        if (prev.discountType == 1) {
          // 特价：不做范围限制
        } else {
          // 折扣：0-100
          if (val < 0 || val > 100) {
            return;
          }
        }
        setData((d) =>
          d.map((item) =>
            item.id === prev.id
              ? { ...item, price: price || null }
              : item,
          )
        );
      },
      render: function PriceCell(_: any, r: any) {
        if (r.price == null) return "";
        const num = parseFloat(r.price);
        const displayValue = r.discountType == 1
          ? num.toFixed(5)
          : String(Math.round(num));
        if (!r.retailPrice || parseFloat(r.retailPrice) <= 0) {
          return displayValue;
        }
        const retailPrice = parseFloat(r.retailPrice);
        let popoverContent: string;
        if (r.discountType == 1) {
          // 特价：折扣比例 = 会员价 / 目录售价 * 100
          const ratio = Math.round((num / retailPrice) * 100);
          popoverContent = `折扣比例：${ratio}%`;
        } else {
          // 折扣：折后价 = 目录售价 * 折扣%
          const discounted = (retailPrice * num / 100).toFixed(5);
          popoverContent = `折后价：${discounted}元`;
        }
        return (
          <Popover content={popoverContent} overlayClassName={styles.pricePopover}>
            <span>{displayValue}</span>
          </Popover>
        );
      },
    },
    {
      dataIndex: "unit",
      align: "center" as const,
      key: "unit",
      width: "4rem",
      colSpan: 0,
      className: 'noRowSelect',
      render: function UnitCell(_: any, r: any) {
        const selected = selectedRowKeys.includes(r.id)
        return <span style={{ color: selected ? undefined : '#bbb' }}>{r.discountType == 1 ? '元' : '%'}</span>
      },
    },
  ];

  const fullColumns =
    mode === "full"
      ? columns
      : columns.filter(
          (col: any) =>
            !["discountType", "price", "unit"].includes(col.dataIndex),
        );

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      confirmLoading={submitLoading}
      maskClosable={false}
      width={1200}
      destroyOnClose
    >
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Form form={form} layout="inline" onFinish={handleSearch}>
          <Form.Item name="allStr" style={{ marginBottom: 0 }}>
            <Input
              placeholder="商品名称/助记码"
              allowClear
              prefix={<SearchOutlined />}
              style={{ width: 200 }}
              onChange={handleQuery}
            />
          </Form.Item>
          <Form.Item name="materialsCategory" style={{ marginBottom: 0 }}>
            <Cascader
              options={treeData}
              onChange={handleQuery}
              multiple
              maxTagTextLength={12}
              changeOnSelect
              placeholder="商品类别"
              expandTrigger="hover"
              dropdownRender={dropdownRender}
              style={{ width: 160 }}
            />
          </Form.Item>
          {mode !== 'exception' && (
            <Form.Item name="billingCategory" style={{ marginBottom: 0 }}>
            <Select
              placeholder="开票项目"
              allowClear
              style={{ width: 160 }}
              onChange={handleQuery}
            >
              {InvoiceBillingCategories.map((v) => (
                <Select.Option value={v} key={v}>
                  {BillingCategoryName(v)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          )}
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit">
              查询
            </Button>
          </Form.Item>
        </Form>
        <Space>
          <span>已选择 {selectedRowKeys.length} 条</span>
          <Checkbox
            checked={showSelectedOnly}
            onChange={(e) => {
              setShowSelectedOnly(e.target.checked)
              setQueries({ size: 10, current: 1, state: 1 })
            }}
          >
            查看已选
          </Checkbox>
        </Space>
      </Row>

      <EditableList
        loading={pageLoading}
        rowKey={(t: any) => t.id}
        bordered
        onRow={(record: any) => ({
          onClick: (e: React.MouseEvent) => {
            // 点击可编辑单元格区域时不触发行选中切换
            const target = e.target as HTMLElement
            if (target.closest('input') || target.closest('textarea') || target.closest('[data-field]') || target.closest('.noRowSelect')) {
              return
            }
            const key = record.id
            setSelectedRowKeys((prev) => {
              if (prev.includes(key)) {
                setSelectedRows((s) => s.filter((r: any) => r.id !== key))
                return prev.filter((k) => k !== key)
              }
              setSelectedRows((s) => [...s, record])
              return [...prev, key]
            })
          },
        })}
        rowSelection={rowSelection}
        page={{
          items: pagedData,
          current: currentPage,
          size: pageSize,
          total: displayTotal,
        }}
        onChangePage={(current, pageSize) => {
          setQueries({
            ...queries,
            current,
            size: pageSize,
          });
        }}
        columns={fullColumns}
      />
    </Modal>
  );
};
